function Mosques() {
   return (
    
      <div className="page-container">
          <h1 className="page-title">Mosques</h1>

          <div className="page-content">
            <p>
            To be updated!
            </p>

          </div>
        </div>

  );
}
export default Mosques;